import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { OrderTaxShortTermRentalJoinService } from '../order-tax-short-term-rental-join.service';
import { OrderTaxShortTermRentalJoin } from '../order-tax-short-term-rental-join';
import { OrderTaxService } from '@app/_components/order-tax/order-tax.service';
import { PropertyService } from '@app/_components/property/property.service';

@Component({
    selector: 'app-order-tax-short-term-rental-join',
    templateUrl: './order-tax-short-term-rental-join.component.html',
    styleUrls: ['./order-tax-short-term-rental-join.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OrderTaxShortTermRentalJoinComponent implements OnInit {
	orderTaxId: any;
	orderTaxes: any[]=[];
	properties: any[]=[];
	orderTaxShortTermRentalFlag = false;

	sourceProperties: any[]=[];
	targetProperties: any[]=[];
	orderTaxShortTermRentalJoins: any[]=[];
	isDataLoaded = false;
	applyStaysOfNtsList: any[]=[];
	targetPropertyLength: number;
	shortTermRentalIds: any[]=[];
	orderTaxObj: any[]=[];
	isSearching = false;
	orderTaxShortTermRentalIds: any[]=[];
	selectedFilter: any;
	filters: any;
;

	constructor(
		private primengConfig: PrimeNGConfig,
		private orderTaxShortTermRentalJoinService: OrderTaxShortTermRentalJoinService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private orderTaxService: OrderTaxService,
		private propertyService: PropertyService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.orderTaxShortTermRentalJoin = data?.orderTaxShortTermRentalJoin,
			this.orderTaxShortTermRentalFlag = data?.orderTaxShortTermRentalFlag,
			this.orderTaxId = data?.orderTaxId,
			this.statuses = orderTaxShortTermRentalJoinService.statuses;
			this.filters = orderTaxShortTermRentalJoinService.filters;
			this.selectedFilter = "propertyCode";
			if(this.orderTaxId == undefined){
				this.orderTaxId = this.orderTaxShortTermRentalJoin?.orderTaxId;
			}
	}

	@Input() orderTaxShortTermRentalJoin: OrderTaxShortTermRentalJoin;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	orderTaxShortTermRentalJoinId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'orderTaxId': [{ type: 'required', message: 'Required' }],
		'shortTermRentalId': [{ type: 'required', message: 'Required' }],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();
		this.fetchProperties();
		this.fetchOrderTaxes();

		// if we were passed the whole orderTaxShortTermRentalJoin object
		if (this.orderTaxShortTermRentalJoin) {
			this.orderTaxShortTermRentalJoinId = this.orderTaxShortTermRentalJoin.orderTaxShortTermRentalJoinId;
			this.fixDates();
			this.form1.patchValue(this.orderTaxShortTermRentalJoin);
		}
	}

	fetchOrderTaxes() {
		try {
			this.orderTaxService.findAllOrderTaxes()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.orderTaxes = res.data.taxs;
						return this.orderTaxes;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
}

fetchProperties() {
	try {
		this.propertyService.propertySummaryForShortData()
			.subscribe(
				res => {
					// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
					this.properties = res.data.properties;
					this.fetchOrderTaxShortTermRentalJoinByOrderTaxId();

					return this.properties;
				},
				err => {
					console.log('Feature-Update FAIL: ' + JSON.stringify(err));
					this.alertService.error(err);
				},
				() => { });
	} catch (error) {
		console.log('Form Invalid: ' + JSON.stringify(error));
		this.alertService.error(error);
	}
}

fetchOrderTaxShortTermRentalJoinByOrderTaxId() {
	if(this.orderTaxId){
	try {
		this.orderTaxShortTermRentalJoinService.getAllByOrderTaxId(this.orderTaxId)
			.subscribe(
				res => {
					// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
					this.orderTaxShortTermRentalJoins = res.data.orderTaxShortTermRentalJoins;
					// this.isDataLoaded = false;
					this.targetProperties = [];
					this.sourceProperties = [];
					
					this.properties.forEach(property => {
						const orderProductHaveProperty = this.orderTaxShortTermRentalJoins.find((e: any) => e.shortTermRentalId == property.shortTermRentalId);
						if(orderProductHaveProperty != null) {
							this.targetProperties.push(property);
						}else{
							this.sourceProperties.push(property);
						}
					});
					this.isDataLoaded = true;
					this.primengConfig.ripple = true;
					
					// return this.orderProductShortTermRentalJoins;
				},
				err => {
					console.log('Feature-Update FAIL: ' + JSON.stringify(err));
					this.alertService.error(err);
				},
				() => { });
	} catch (error) {
		console.log('Form Invalid: ' + JSON.stringify(error));
		this.alertService.error(error);
	}
}else{
	this.sourceProperties = this.properties;
	this.isDataLoaded = true;
}
}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.orderTaxShortTermRentalJoinId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.orderTaxShortTermRentalJoinService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.orderTaxShortTermRentalJoin = res.data.orderTaxShortTermRentalJoin;
						this.doAdd.emit(this.orderTaxShortTermRentalJoin);
					},
					(err: any) => {
						console.log('orderTaxShortTermRentalJoin-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('orderTaxShortTermRentalJoin: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.orderTaxShortTermRentalJoinService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.orderTaxShortTermRentalJoin = res.data.orderTaxShortTermRentalJoin;
						this.doUpdate.emit(this.orderTaxShortTermRentalJoin);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.orderTaxShortTermRentalJoinService.deleteOrderTaxShortTermRentalRelationship(this.orderTaxShortTermRentalJoin.orderTaxId, this.orderTaxShortTermRentalJoin.shortTermRentalId)
				.subscribe(
					(res: any) => {
						console.log('orderTaxShortTermRentalJoin-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.orderTaxShortTermRentalJoin);
					},
					(err: any) => {
						console.log('orderTaxShortTermRentalJoin-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			orderTaxId: [this.orderTaxId, Validators.required],
			shortTermRentalId: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.orderTaxShortTermRentalJoin.orderTaxShortTermRentalJoinDate = moment(this.orderTaxShortTermRentalJoin.orderTaxShortTermRentalJoinDate).toDate();
	}



	moveAllToTarget(event: any){ 
		this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
		this.orderTaxObj = [];
		event.items.forEach(orderTaxShortTermRentalJoin => {
			const dataObj = {
				"orderTaxId":this.orderTaxId,
				"shortTermRentalId":orderTaxShortTermRentalJoin.shortTermRentalId,
			}
			this.orderTaxObj.push(dataObj)
		});
		this.formAddOrderTaxShortTermRentalJoin(this.orderTaxObj);
    }

	moveToTarget(event: any){ 
		this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.orderTaxObj = [];
			event.items.forEach(orderTaxShortTermRentalJoin => {
				const dataObj = {
					"orderTaxId":this.orderTaxId,
					"shortTermRentalId":orderTaxShortTermRentalJoin.shortTermRentalId,
				}
				this.orderTaxObj.push(dataObj)
			});
			this.formAddOrderTaxShortTermRentalJoin(this.orderTaxObj);
    } 

	moveAllToSource(event: any){ 
		this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
		this.orderTaxShortTermRentalIds = [];
		event.items.forEach(orderTaxShortTermRentalJoin => {
			this.orderTaxShortTermRentalIds.push(orderTaxShortTermRentalJoin.shortTermRentalId)
		});
		this.deleteOrderTaxShortTermRentalsRelationship(this.orderTaxShortTermRentalIds);
    } 
    moveToSource(event: any){ 
		this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.orderTaxShortTermRentalIds = [];
			event.items.forEach(orderTaxShortTermRentalJoin => {
				this.orderTaxShortTermRentalIds.push(orderTaxShortTermRentalJoin.shortTermRentalId)
			});
			this.deleteOrderTaxShortTermRentalsRelationship(this.orderTaxShortTermRentalIds);
    }

	deleteOrderTaxShortTermRentalsRelationship(shortTermRentalIds: any[]) {
		this.isSearching = true;
		try {
			this.orderTaxShortTermRentalJoinService.deleteOrderProductShortTermRentalsRelationship(this.orderTaxId, shortTermRentalIds)
				.subscribe(
					(res: any) => {
						this.isSearching = false;
						// console.log('orderProductShortTermRentalJoin-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: "Successfully move into Available Units" });
						this.doUpdate.emit(null);
						this.doAdd.emit(null);
					},
					(err: any) => {
						this.isSearching = false;
						console.log('orderTaxShortTermRentalJoin-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });
		} catch (error) {
			this.isSearching = false;
			this.alertService.error(error);
		}
	}

	formAddOrderTaxShortTermRentalJoin(orderProductObj: any[]) {
		this.isSearching = true;
		try {
			this.orderTaxShortTermRentalJoinService.addAll(orderProductObj)
				.subscribe(
					(res: any) => {
						this.isSearching = false;
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: "Successfully move into Selected Units" });
						this.doUpdate.emit(null);
						this.doAdd.emit(null);
					},
					(err: any) => {
						this.isSearching = false;
						console.log('orderProductShortTermRentalJoin-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });

		} catch (error) {
			this.isSearching = false;
			this.alertService.error(error);
		}
	}

	setOrderTaxId(event: any){
		this.orderTaxId = event.value;
		this.fetchOrderTaxShortTermRentalJoinByOrderTaxId();
	}

	selectedFilters(event: any){
		this.selectedFilter = event.value;
	}
}
